import React from 'react'
import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom"
import './Device.module.css'
import { Services } from '@/services/services';
import { TeltonikaRow } from '@/services/model/teltonika';
import { CurrentSession } from '@/services/repository/session';
import { Machine } from '@/services/model/machine';
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout';


export const SuperadminTeltonikaDevicePage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const [row, setRow] = useState<TeltonikaRow>()
  const [machine, setMachine] = useState<Machine>()
  const [imei, setIMEI] = useState<string>()
  let machineId = useParams().mid

  useEffect(() => {
    if (machine?.imei === '' || machine?.imei === undefined) {
      return
    }
    const imei = machine.imei

    let id = services.teltonika.watcher.get(imei)!.listen((o: TeltonikaRow | undefined) => {
      setRow(o)
    })

    return () => {
      if (id === undefined) {
        return
      }
      services.teltonika.watcher.get(imei)!.remove(id)
    };
  }, [machine])

  useEffect(() => {
    if (machine?.imei === '' || machine?.imei === undefined) {
      return
    }
    const imei = machine.imei
    fetch(`/api/schema/teltonika/byimei/${imei}`).then((resp) => {
      return resp.json()
    }).then((data) => {
      if (row === undefined) {
        setRow(data)
      }
    });
  }, [machine])

  useEffect(() => {
    if (machineId === undefined) {
      return
    }
    services.session.fetchWithToken(`/api/superadmin/machines/byid/${machineId}`).then((r) => r.json()).then((data) => {
      setMachine(data)
    })
  }, [machineId]);

  if(machine===undefined) {
    return <div className='spinner'></div>
  }

  return <LoggedInPageLayout pageName='superadmin-teltonika' services={services} session={session}>
    <h2>Teltonika device by {machine?.imei} imei for {machine?.name} machine </h2>
    <table>
      <tr>
        <th>Stacyjka (Io239):</th>
        <td>{row?.params?.io239 !== undefined ? (row.params.io239 ? 'on' : 'off') : '-'}</td>
      </tr>
      <tr>
        <th>Napięcie baterii (Io66):</th>
        <td>{row?.params?.io66 !== undefined ? (row.params.io66.toFixed(2) + 'V') : '-'}</td>
      </tr>
      <tr>
        <th>Motogodziny (Io900):</th>
        <td>{row?.params?.io900 !== undefined ? (row.params.io900.toFixed(2) + 'mth') : '-'}</td>
      </tr>
    </table>
    <p>
      {JSON.stringify(row)}
    </p>
  </LoggedInPageLayout>
};
